import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';

import useBranch from 'client/hooks/useBranch';

import SrBox from 'client/components/SrBox';

const getFormValues = () => {
  return {
    dateOfBirth: '1980-05-25T06:00:00.000Z',
    ssn: '304128712',
    confirmSsn: '304128712',
    noSsn: false,
    currentAddressStreetName: '2010 W 80th St',
    currentAddressCity: 'Fantasy Island',
    currentAddressStateCode: 'IL',
    currentAddressZip: '60750',
  };
};

const SrRentalApplicationFlowTestPersonalInfo = ({ formikBag }) => {
  const { appUrl } = useBranch({
    appUrl: ['env', 'APP_URL'],
  });

  const onClickButton = () => {
    const formValues = getFormValues();

    for (const formFieldId of Object.keys(formValues)) {
      formikBag.setFieldValue(formFieldId, formValues[formFieldId]);
    }
  };

  if (url.parse(appUrl).hostname === 'sunroomrentals.com') {
    return null;
  }

  return <SrBox onClick={onClickButton} className="floatButton merge" left="30px" bottom="140px" />;
};

SrRentalApplicationFlowTestPersonalInfo.propTypes = {
  formikBag: PropTypes.object.isRequired,
};

SrRentalApplicationFlowTestPersonalInfo.displayName = 'SrRentalApplicationFlowTestPersonalInfo';

export default SrRentalApplicationFlowTestPersonalInfo;
